"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _keycode = _interopRequireDefault(require("keycode"));

var _addMonths = _interopRequireDefault(require("date-fns/addMonths"));

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));

var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));

var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));

var _eachDayOfInterval = _interopRequireDefault(require("date-fns/eachDayOfInterval"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _miniCalendar = _interopRequireDefault(require("@amzn/meridian-tokens/component/mini-calendar"));

var _chevronRightSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/chevron-right-small"));

var _chevronLeftSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/chevron-left-small"));

var _elevation = require("@amzn/meridian-tokens/base/elevation");

var _miniCalendarPage = _interopRequireDefault(require("./mini-calendar-page"));

var _button = _interopRequireDefault(require("../button"));

var _icon = _interopRequireDefault(require("../icon"));

var _focus = _interopRequireDefault(require("../_focus"));

var _carouselController = _interopRequireDefault(require("../_carousel-controller"));

var _theme = require("../theme");

var _token = require("./../_utils/token");

var _dateString = require("./../_utils/date-string");

var _dateLocales = _interopRequireDefault(require("./../_utils/date-locales"));

var _intlDateTimeFormat = require("./../_utils/intl-date-time-format");

var _visuallyHidden = _interopRequireDefault(require("./../_styles/visually-hidden"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var monthFormat = {
  month: "long",
  year: "numeric"
};
var justMonthFormat = {
  month: "long"
};
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var monthsInView = _ref.monthsInView,
      monthWidth = _ref.monthWidth;
  return (0, _emotion.css)({
    boxSizing: "border-box",
    width: (monthWidth || t("monthWidth")) * monthsInView + t("spacingInset") * (monthsInView + 1),
    position: "relative",
    "& > span": _visuallyHidden["default"],
    // Month navigation buttons
    "& > button": {
      position: "absolute",
      // NOTE: Scoot the nav buttons up by half the difference between the height
      // of the button (32px) and the height of the DayInput month header (24px).
      // The resulting 4px shift will ensure that the button and the header are
      // vertically aligned. A simpler flex-box based solution can't be used
      // because the button and the header can't be siblings (becuse the header
      // must shift left/right as the user changes the view but the button must
      // remain fixed).
      top: t("spacingInset") - 4,
      zIndex: _elevation.elevationForeground,
      "&:nth-of-type(1)": (0, _defineProperty2["default"])({
        left: t("spacingInset")
      }, "[dir=\"rtl\"] &", {
        right: t("spacingInset"),
        left: "auto"
      }),
      "&:nth-of-type(2)": (0, _defineProperty2["default"])({
        right: t("spacingInset")
      }, "[dir=\"rtl\"] &", {
        left: t("spacingInset"),
        right: "auto"
      })
    }
  });
}, ["monthsInView", "monthWidth"]);
var containerStyles = (0, _emotion.css)({
  outline: "none"
});
/**
 * This component renders a month calendar and allows the user to either select
 * a day in the current month or to browse other months.
 */

var MiniCalendar = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MiniCalendar, _React$Component);

  var _super = _createSuper(MiniCalendar);

  function MiniCalendar() {
    var _this;

    (0, _classCallCheck2["default"])(this, MiniCalendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      focusDate: (0, _dateString.toDateString)((0, _startOfMonth["default"])((0, _parseISO["default"])(_this.props.viewDate)))
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])("mini-cal-"));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNextDate", function (date, step) {
      return (0, _dateString.toDateString)((0, _addDays["default"])((0, _parseISO["default"])(date), step));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onShiftViewDate", function (months) {
      if (months !== 0) {
        var _this$props = _this.props,
            viewDate = _this$props.viewDate,
            onChangeViewDate = _this$props.onChangeViewDate,
            monthsInView = _this$props.monthsInView;
        onChangeViewDate((0, _dateString.toDateString)((0, _addMonths["default"])((0, _parseISO["default"])(viewDate), months)));
        var focusDate = _this.state.focusDate;
        var startOfView = (0, _startOfMonth["default"])((0, _parseISO["default"])(viewDate));
        var endOfView = (0, _endOfMonth["default"])((0, _addMonths["default"])((0, _parseISO["default"])(viewDate), monthsInView - 1)); // Make sure the focused day is in view when the user focuses on the input

        var focusInView = focusDate && (0, _dateString.isWithinRange)(focusDate, (0, _dateString.toDateString)(startOfView), (0, _dateString.toDateString)(endOfView)); // If the focus date is no longer in view, set focus date to first date in
        // the new view

        if (!focusInView) {
          _this.setState({
            focusDate: (0, _dateString.toDateString)(startOfView)
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickDate", function (date) {
      if (_this.props.onClickDate) {
        _this.props.onClickDate(date);
      }

      _this.setState({
        focusDate: date
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusDayElement", function (date) {
      try {
        var dayElement = document.getElementById("".concat(_this.id, "-").concat(date));
        dayElement.focus();
      } catch (_) {// Silent error
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownCalendarPage", function (event) {
      var _this$props2 = _this.props,
          viewDate = _this$props2.viewDate,
          monthsInView = _this$props2.monthsInView,
          onClickDate = _this$props2.onClickDate;
      var focusDate = _this.state.focusDate;
      var key = (0, _keycode["default"])(event);
      var dayChange = {
        up: -7,
        right: 1,
        down: 7,
        left: -1
      }[key];
      var nextFocusDate = focusDate && dayChange ? _this.getNextDate(focusDate, dayChange) : undefined;
      var keyUsed = false; // Move the focus to a new date when the user navigates with arrow keys

      if (nextFocusDate && nextFocusDate !== focusDate) {
        _this.setState({
          focusDate: nextFocusDate
        });

        _this.focusDayElement(nextFocusDate); // If the user focused a date outside of the view then change the view


        var differenceInMonths = (0, _dateString.differenceInMonthsFromRange)(nextFocusDate, viewDate, (0, _dateString.toDateString)((0, _addMonths["default"])((0, _parseISO["default"])(viewDate), monthsInView - 1)));

        _this.onShiftViewDate(differenceInMonths);

        keyUsed = true;
      } // Select the focused date when the user hits enter or space


      if (focusDate && (key === "enter" || key === "space")) {
        if (!_this.props.disabledDates(focusDate)) {
          onClickDate(focusDate);
          keyUsed = true;
        }
      } // Don't perform the normal action associated with the key (e.g. scroll for
      // arrows/space) if the key was used for an input-related action


      if (keyUsed) {
        event.preventDefault();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocusCalendarPage", function () {
      var _this$props3 = _this.props,
          viewDate = _this$props3.viewDate,
          monthsInView = _this$props3.monthsInView,
          disabledDates = _this$props3.disabledDates;
      var focusDate = _this.state.focusDate;
      var startOfView = (0, _startOfMonth["default"])((0, _parseISO["default"])(viewDate));
      var endOfView = (0, _endOfMonth["default"])((0, _addMonths["default"])((0, _parseISO["default"])(viewDate), monthsInView - 1)); // Make sure the focused day is in view when the user focuses on the input

      var focusInView = focusDate && (0, _dateString.isWithinRange)(focusDate, (0, _dateString.toDateString)(startOfView), (0, _dateString.toDateString)(endOfView));
      var nextFocusDate = !focusInView ? (0, _eachDayOfInterval["default"])({
        start: startOfView,
        end: endOfView
      }).map(function (date) {
        return (0, _dateString.toDateString)(date);
      }).filter(function (date) {
        return !disabledDates(date);
      })[0] : undefined;

      if (nextFocusDate) {
        _this.setState({
          focusDate: nextFocusDate
        });

        _this.focusDayElement(nextFocusDate);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(MiniCalendar, [{
    key: "renderNavButton",
    value: function renderNavButton(direction) {
      var _this2 = this;

      var _this$props4 = this.props,
          previousMonthLabel = _this$props4.previousMonthLabel,
          nextMonthLabel = _this$props4.nextMonthLabel,
          viewDate = _this$props4.viewDate,
          locale = _this$props4.locale;
      var _left$right$direction = {
        left: {
          icon: _chevronLeftSmall["default"],
          change: -1,
          label: previousMonthLabel
        },
        right: {
          icon: _chevronRightSmall["default"],
          change: 1,
          label: nextMonthLabel
        }
      }[direction],
          icon = _left$right$direction.icon,
          change = _left$right$direction.change,
          label = _left$right$direction.label; // Get a formatted localized string for the target month and add it to the label
      // e.g. "Next month, November 2018"

      var targetMonthLabel = (0, _intlDateTimeFormat.intlDateTimeFormat)((0, _addMonths["default"])((0, _parseISO["default"])(viewDate), change), monthFormat, locale);
      return /*#__PURE__*/_react["default"].createElement(_button["default"], {
        type: "icon",
        size: "small",
        onClick: function onClick() {
          return _this2.onShiftViewDate(change);
        },
        label: "".concat(label, ", ").concat(targetMonthLabel)
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        tokens: icon
      }));
    }
  }, {
    key: "getScreenReaderMonthLabel",
    value: function getScreenReaderMonthLabel() {
      var props = this.props;
      var currentMonth = (0, _parseISO["default"])(props.viewDate);
      var nextMonth = (0, _addMonths["default"])((0, _parseISO["default"])(props.viewDate), 1); // If we're showing two months, return the current month by itself plus the
      // next month including year
      // e.g. "October & November 2018"

      if (props.monthsInView > 1) {
        return "".concat((0, _intlDateTimeFormat.intlDateTimeFormat)(currentMonth, justMonthFormat, props.locale), " & ").concat((0, _intlDateTimeFormat.intlDateTimeFormat)(nextMonth, monthFormat, props.locale));
      } // Else, return the current month plus the year
      // e.g. "October 2018"
      else {
        return (0, _intlDateTimeFormat.intlDateTimeFormat)(currentMonth, monthFormat, props.locale);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;
      var state = this.state;
      var viewDateIndex = (0, _dateString.differenceInCalendarMonths)(props.viewDate, props.now);
      var screenReaderMonthLabel = this.getScreenReaderMonthLabel();
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _miniCalendar["default"],
        map: (0, _token.getTokenHelper)("miniCalendar")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: styles(t, {
            monthsInView: props.monthsInView,
            monthWidth: props.monthWidth
          })
        }, _this3.renderNavButton("left"), /*#__PURE__*/_react["default"].createElement("span", {
          "aria-live": "polite"
        }, screenReaderMonthLabel), _this3.renderNavButton("right"), /*#__PURE__*/_react["default"].createElement(_focus["default"], {
          onFocus: _this3.onFocusCalendarPage
        }, function (_ref2) {
          var focusProps = _ref2.focusProps,
              focusTrigger = _ref2.focusTrigger;
          return /*#__PURE__*/_react["default"].createElement(_carouselController["default"], {
            renderContainer: function renderContainer(_ref3) {
              var containerProps = _ref3.props;
              return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, containerProps, {
                className: (0, _emotion.cx)(containerProps.className, containerStyles),
                onKeyDown: _this3.onKeyDownCalendarPage
              }, focusProps));
            },
            renderSlide: function renderSlide(_ref4) {
              var slideProps = _ref4.props,
                  index = _ref4.index;
              return /*#__PURE__*/_react["default"].createElement(_miniCalendarPage["default"], (0, _extends2["default"])({}, slideProps, {
                hidden: slideProps["aria-hidden"],
                t: t,
                focusDate: state.focusDate,
                showFocusRing: focusTrigger === "keyboard",
                viewDate: (0, _dateString.toDateString)((0, _addMonths["default"])((0, _parseISO["default"])(props.now), index)),
                now: props.now,
                selectedDates: props.selectedDates,
                rangeDates: props.rangeDates,
                disabledDates: props.disabledDates,
                dateIds: function dateIds(date) {
                  return "".concat(_this3.id, "-").concat(date);
                },
                locale: props.locale,
                onClickDate: _this3.onClickDate,
                onMouseEnterDate: props.onMouseEnterDate,
                renderDate: props.renderDate,
                renderDay: props.renderDay,
                dateLabel: props.dateLabel
              }));
            },
            slideIndex: viewDateIndex,
            slidesInView: props.monthsInView,
            motionDuration: props.animateMonthChange ? parseInt(t("monthMotionDuration")) : 0,
            motionFunction: t("monthMotionFunction"),
            spacingInset: t("spacingInset"),
            spacingHorizontal: t("spacingInset")
          });
        }), props.children);
      });
    }
  }]);
  return MiniCalendar;
}(_react["default"].Component);

(0, _defineProperty2["default"])(MiniCalendar, "defaultProps", {
  locale: "en-US",
  previousMonthLabel: "Previous month",
  nextMonthLabel: "Next month",
  monthsInView: 1,
  now: (0, _dateString.toDateString)(new Date()),
  onClick: _noop["default"],
  selectedDates: function selectedDates() {
    return false;
  },
  rangeDates: function rangeDates() {
    return false;
  },
  disabledDates: function disabledDates() {
    return false;
  },
  animateMonthChange: true
});
MiniCalendar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This date is used to determine which month the calendar should display
   * by default. The date must be provided in the format YYYY-MM-DD.
   */
  viewDate: _propTypes["default"].string.isRequired,

  /**
   * A function that will be called whenever the calendar wants to update the
   * view date itself.
   */
  onChangeViewDate: _propTypes["default"].func.isRequired,

  /**
   * Determines whether changing months is animated with a sliding motion.
   */
  animateMonthChange: _propTypes["default"].bool,

  /**
   * Children to be rendered in the container div, after the calendar itself.
   * This is an advanced feature meant for internal use.
   */
  children: _propTypes["default"].node,

  /**
   * A function that can be used to construct a screen-reader label for a particular
   * day. The function will be passed an object with the following properties.
   * ```
   * date:      `string` of date in the format YYYY-MM-DD
   * label:     `string` of the localized day of the month (e.g. "Thursday, Nov 22, 2018")
   * current:   `boolean` set to `true` if the date is today's date
   * selected:  `boolean` set to `true` if date is selected
   * disabled:  `boolean` set to `true` if date is disabled
   * range:     `boolean` set to `true` if date is in the range of selected dates
   * ```
   *
   * @since 5.20.0
   */
  dateLabel: _propTypes["default"].func,

  /**
   * A function that can be used to disable specific dates. The function will
   * be passed date strings in the format YYYY-MM-DD and is expected to return
   * true for disabled dates and false otherwise.
   */
  disabledDates: _propTypes["default"].func,

  /**
   * The locale to use when rendering the input (e.g. month names, names of
   * days of the week, etc.). See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl)
   * for more information about date internationalization in JS.
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * Set the width of a single month.
   */
  monthWidth: _propTypes["default"].number,

  /**
   * The number of calendar months to display at a time.
   */
  monthsInView: _propTypes["default"].number,

  /**
   * A localized label for the next month button.
   */
  nextMonthLabel: _propTypes["default"].string,

  /**
   * Define today's date (in the format YYYY-MM-DD). This date will be
   * marked in the calendar with a special indicator.
   */
  now: _propTypes["default"].string,

  /**
   * A localized label for the previous month button.
   */
  previousMonthLabel: _propTypes["default"].string,

  /**
   * A function that can be used to display specific dates as part of a range.
   * The function will be passed date strings in the format YYYY-MM-DD and is
   * expected to return true for dates in the range and false otherwise.
   */
  rangeDates: _propTypes["default"].func,

  /**
   * A function that can be used to customize the rendering of a single day. The
   * function is passed an object which contains the following properties.
   * ```
   * date:      `string` of date in the format YYYY-MM-DD
   * label:     `string` of the localized day of the month (e.g. "21")
   * current:   `boolean` set to `true` if the date is today's date
   * selected:  `boolean` set to `true` if date is selected
   * disabled:  `boolean` set to `true` if date is disabled
   * range:     `boolean` set to `true` if date is in the range of selected dates
   * ```
   */
  renderDate: _propTypes["default"].func,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `renderDate` instead.
   *
   * @deprecated 5.20.0
   */
  renderDay: _propTypes["default"].func,

  /**
   * A function that can be used to display specific dates as selected. The
   * function will be passed date strings in the format YYYY-MM-DD and is
   * expected to return true for selected dates and false otherwise.
   */
  selectedDates: _propTypes["default"].func,

  /**
   * A function that will be called when the user clicks on a date in the
   * calendar. The date will be passed to the function as a string with the
   * the format YYYY-MM-DD.
   */
  onClickDate: _propTypes["default"].func,

  /**
   * A function that will be called when the user hovers over a date in the
   * calendar. The date will be passed to the function as a string with the
   * format YYYY-MM-DD.
   */
  onMouseEnterDate: _propTypes["default"].func
} : {};
var _default = MiniCalendar;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/_mini-calendar/mini-calendar.js
// module id = 471
// module chunks = 0